import PassportizationTab from './container'

export default PassportizationTab